import React from 'react'
import {
    CircularProgress,
} from '@material-ui/core'
import { DeedTypography, TextHighlight } from '../Atoms'
// import { SearchService } from '../../services'
import { makeStyles } from '@material-ui/styles'


const useStyles = makeStyles(() => ({
    fadeOutContent: {
        position: 'relative',
        '&:after': {
            position: 'absolute',
            bottom: 0,
            content: '""',
            background: 'linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,1), rgba(255,255,255,1))',
            height: '100%',
            width: '100%',
        }
    },
    fadeInContent: {
        position: 'relative',
        '&:after': {
            position: 'absolute',
            bottom: 0,
            content: '""',
            background: 'linear-gradient(rgba(255,255,255,1), rgba(255,255,255,1), rgba(255,255,255,0.5))',
            height: '100%',
            width: '100%',
        }
    },
}))

function FullDocument({ originalClause }) {
    const classes = useStyles()
    const [previousClause, setPreviousClause] = React.useState(null)
    const [nextClause, setNextClause] = React.useState(null)
    const [loading, setLoading] = React.useState(true)
    // const scrollRef = React.useRef(null)

    React.useEffect(() => {
        let isSubscribed = true
        if (isSubscribed) {
            setPreviousClause(null)
            setNextClause(null)
            setLoading(false)
        }
        // setLoading(true)
        // SearchService.getDeedById(originalClause.deed_id)
        //     .then(result => {
        //         if (isSubscribed) {
        //             const previousClause = result.documents.filter(({ clause_order }) => clause_order === originalClause.clause_order - 1)
        //             previousClause && setPreviousClause(previousClause[0])
        //             const nextClause = result.documents.filter(({ clause_order }) => clause_order === originalClause.clause_order + 1)
        //             nextClause && setNextClause(nextClause[0])
        //             setLoading(false)
        //         }
        //     })

        return () => isSubscribed = false
    }, [originalClause])

    // const executeScroll = () => {
    // if (scrollRef.current) scrollRef.current.scrollIntoView()
    // }

    // React.useEffect(executeScroll, [scrollRef, loading])

    const renderMainClause = ({ html, text, highlight }) => {
        return (
            <React.Fragment>
                {/* <div
                    ref={scrollRef}
                    style={{ position: 'relative', top: -100 }}
                /> */}
                <div>
                    {html
                        ? <div dangerouslySetInnerHTML={{ __html: highlight && highlight.html_highlight ? highlight.html_highlight : html }} />
                        : <TextHighlight
                            text={text}
                            highlighted_text={
                                highlight
                                && highlight.text_highlight
                                && highlight.text_highlight.length > 0
                                && highlight.text_highlight
                            }
                        />
                    }
                </div>
            </React.Fragment>
        )
    }

    const renderOtherClause = ({ html, text }, { fadeIn = false, fadeOut = false }) => {
        return (
            <div className={fadeIn ? classes.fadeInContent : fadeOut ? classes.fadeOutContent : {}}>
                {
                    html
                        ? <div dangerouslySetInnerHTML={{ __html: html }} />
                        : <DeedTypography>{text}</DeedTypography>
                }
            </div>
        )
    }

    if (loading) return <CircularProgress />

    return <React.Fragment>
        {previousClause
            && <div>
                {renderOtherClause(previousClause, { fadeIn: true })}
            </div>}
        {originalClause
            && <div>
                {renderMainClause(originalClause)}
            </div>}
        {nextClause
            && <div>
                {renderOtherClause(nextClause, { fadeOut: true })}
            </div>}
    </React.Fragment>
}

export default FullDocument